import { useState } from 'react'
import AuthService from 'services/auth'
import InfiniteScroll from 'react-infinite-scroll-component'
import Business from './Business'
import AdminBusinessDetailsModal from 'pages/Admin/Modals/BusinessDetailsModal'
import CompanyBusinessDetailsModal from 'pages/Company/Modals/BusinessDetailsModal'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, SubTitle } from './styles'

export default function BusinessList ({
  businesses = [],
  hasMore,
  totalBusinesses,
  onUpdate: handleUpdate = () => null,
  onScroll: handleScroll = () => null
}) {
  const [selectedBusiness, setSelectedBusiness] = useState (null)
  const [showBusinessDetails, setShowBusinessDetails] = useState (false)
  const userType = AuthService.getUserType ()

  const handleSelect = business => {
    setSelectedBusiness (business)
    setShowBusinessDetails (true)
  }

  return (
    <Container>
      <SubTitle>
        {totalBusinesses + ' ' + (totalBusinesses === 1 ? 'Resultado' : 'Resultados')}
      </SubTitle>
      <InfiniteScroll
        dataLength={businesses.length}
        next={handleScroll}
        hasMore={hasMore}
        loader={<Loading/>}
        endMessage={<div style={{height: 50}}></div>}
        style={{overflow: 'visible'}}
      >
        {businesses.map (business => (
          <Business
            key={business.id}
            data={business}
            onSelect={handleSelect}
          />
        ))}
      </InfiniteScroll>
      {userType === 'admin' ? (
        <AdminBusinessDetailsModal
          visible={showBusinessDetails}
          data={selectedBusiness}
          onUpdate={business => {
            handleUpdate (business)
            setSelectedBusiness (business)
          }}
          onClose={() => {
            setShowBusinessDetails (false)
            setSelectedBusiness (null)
          }}
        />
      ) : (
        <CompanyBusinessDetailsModal
          visible={showBusinessDetails}
          data={selectedBusiness}
          onClose={() => {
            setShowBusinessDetails (false)
            setSelectedBusiness (null)
          }}
        />
      )}
    </Container>
  )
}
